<template>
  <transition name="fade">
    <div class="comment-dialog" :class="{ active }" v-if="visible" @click.stop>
      <div class="comment-header">
        <div class="comment-title"><span v-if="!submitted">您对当前页面的整体感受是否满意？</span></div>
        <div class="comment-close" @click.stop="close"><i class="el-icon-close"></i></div>
      </div>
      <div class="comment-submitted" v-if="submitted">
        <div class="comment-submitted-title">感谢您的反馈！({{countDown}}s)</div>
        <div class="comment-submitted-remark">我们将尽快响应，为您提供更好的服务体验</div>
      </div>
      <div class="comment-body" v-loading="loading" v-else>
        <RateSelect v-model="entity.rating" @input="handleRateChange"></RateSelect>
        <div class="comment-form-container">
          <el-form class="comment-form" ref="formRef" :model="entity" :rules="rules" label-position="top">
            <el-form-item label="您感到不满意的原因是？(最多选3项)" prop="evaluationTag" v-if="entity.rating < 4">
              <el-checkbox-group v-model="entity.evaluationTag" :max="3">
                <el-checkbox border label="内容无吸引力"></el-checkbox>
                <el-checkbox border label="页面布局乱"></el-checkbox>
                <el-checkbox border label="内容难理解"></el-checkbox>
                <el-checkbox border label="内容不够丰富"></el-checkbox>
                <el-checkbox border label="页面加载慢"></el-checkbox>
                <el-checkbox border label="引导不清晰"></el-checkbox>
                <el-checkbox border label="咨询体验差"></el-checkbox>
                <el-checkbox border label="流程太复杂"></el-checkbox>
                <el-checkbox border label="反馈无回应"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="您对期望看到哪些改进？(最多选3项)" prop="evaluationTag" v-else>
              <el-checkbox-group v-model="entity.evaluationTag" :max="3">
                <el-checkbox border label="续约服务"></el-checkbox>
                <el-checkbox border label="页面跳转效率"></el-checkbox>
                <el-checkbox border label="页面布局"></el-checkbox>
                <el-checkbox border label="内容丰富度"></el-checkbox>
                <el-checkbox border label="内容吸引力"></el-checkbox>
                <el-checkbox border label="产品规格信息"></el-checkbox>
                <el-checkbox border label="定价模式"></el-checkbox>
                <el-checkbox border label="更多试用权益"></el-checkbox>
                <el-checkbox border label="更多促销信息"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="期待您的建议或联系方式，帮助我们更好地优化" prop="remark">
              <el-input
                type="textarea"
                v-model="entity.remark"
                maxlength="250"
                :autosize="{ minRows: 2, maxRows: 4 }"
                resize="none"
                show-word-limit
                placeholder="请描述您的需求场景与改进建议"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="linkMan">
              <el-input v-model="entity.linkMan" maxlength="20" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="linkWay">
              <el-input v-model="entity.linkWay" maxlength="50" placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <div class="action-bar">
              <div class="primary-btn" @click="submit">提交</div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { addModel } from '@/api/system/feedBackApi';
import RateSelect from './RateSelect.vue';
export default {
  components: { RateSelect },
  data() {
    return {
      visible: false,
      active: false, // 是否激活评论表单
      loading: false,
      entity: {
        rating: 0,
        evaluationTag: [],
        remark: '',
        linkMan: '',
        linkWay: '',
      },
      rules: {},
      submitted: false,
      countDown: 3,
      timer: null,
    }
  },
  watch: {
    'entity.rating'(newVal, oldVal) {
      if (oldVal === 0 && newVal > 0) this.active = true;
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      if (this.timer) clearInterval(this.timer);
      if (this.submitted) {
        setTimeout(() => {
          this.countDown = 3;
          this.submitted = false;
        }, 300);
      }
    },
    handleRateChange() {
      if (this.entity.rating < 4) {
        this.rules = {
          evaluationTag: [{ required: true, message: '请选择您感到不满意的原因' }],
          remark: [{ required: true, message: '请输入您的建议' }],
        };
      } else {
        this.rules = {};
      }
      this.$nextTick(() => {
        this.$refs.formRef.resetFields();
        this.resetEntity();
      });
    },
    resetEntity() {
      this.entity.evaluationTag = [];
      this.entity.remark = '';
      this.entity.linkMan = '';
      this.entity.linkWay = '';
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const data = { ...this.entity, evaluationTag: this.entity.evaluationTag?.join(',') };
        addModel(data).then(res => {
          if (res?.code === '00000') this.handleSubmitted();
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    handleSubmitted() {
      this.resetEntity();
      this.entity.rating = 0;
      this.active = false;
      this.submitted = true;
      this.timer = setInterval(() => {
        if (this.countDown > 1) this.countDown--;
        else this.close();
      }, 1000);
    }
  },
};
</script>

<style lang="less" scoped>
.comment-dialog {
  width: 420px;
  padding: 20px;
  background-image: url('@/assets/img/layout/FloatWindow/bg_dialog.png');
  background-position: left top;
  background-repeat: no-repeat;
  background-color: #fff;
  box-shadow: -7px 0px 20px 0px rgba(0,0,0,0.06);
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translate(-100%, 85px);
  transition: all 0.3s ease;
  &.fade-enter,
  &.fade-leave-to {
    transform: translate(calc(-100% + 25px), 85px);
    opacity: 0;
  }
  &.active {
    top: 50%;
    transform: translate(-100%, -50%);
    .comment-body > .comment-form-container {
      grid-template-rows: 1fr;
    }
    &.fade-enter,
    &.fade-leave-to {
      transform: translate(calc(-100% + 25px), -50%);
      opacity: 0;
    }
  }

  .comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .comment-title {
      font-family: @font-medium;
      line-height: 38px;
    }
    .comment-close {
      font-size: 22px;
      color: #666;
      cursor: pointer;
      &:hover {
        color: @primary-color;
      }
    }
  }

  .comment-submitted {
    margin-top: -40px;
    padding: 108px 0 20px;
    background-image: url('@/assets/img/layout/FloatWindow/bg_submitted.png');
    background-position: center top;
    background-repeat: no-repeat;
    text-align: center;
    .comment-submitted-title {
      font-family: @font-medium;
      font-size: 20px;
    }
    .comment-submitted-remark {
      margin-top: 12px;
      font-size: 14px;
      color: #666;
    }
  }

  .comment-body {
    .comment-form-container {
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.3s ease;
      overflow: hidden;
      :deep(.comment-form) {
        min-height: 0;
        margin-top: 12px;
        .el-form-item__label {
          padding-bottom: 0;
          font-family: @font-medium;
          color: @default-color;
        }
        .el-form-item__content {
          line-height: normal;
        }
        textarea,
        input {
          font-family: @font-regular;
          padding-left: 10px;
          padding-right: 10px;
        }

        .el-checkbox-group {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          .el-checkbox {
            height: auto;
            margin: 0;
            padding: 0;
            border-radius: 2px;
            text-align: center;
            .el-checkbox__input {
              display: none;
            }
            .el-checkbox__label {
              padding: 0;
              line-height: 30px;
            }
          }
        }

        .action-bar {
          display: flex;
          justify-content: flex-end;
          .primary-btn {
            width: 92px;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
